import { render } from "./TopperListView.vue?vue&type=template&id=25d89740"
import script from "./TopperListView.vue?vue&type=script&lang=js"
export * from "./TopperListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__